// src/pages/TermsOfService.js
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const TermsOfService = () => {
  const { language } = useLanguage();
  const isArabic = language === 'ar';

  const containerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: isArabic ? 'Cairo, sans-serif' : 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    lineHeight: '1.6',
    direction: isArabic ? 'rtl' : 'ltr',
    textAlign: isArabic ? 'right' : 'left'
  };

  const headingStyle = {
    color: '#3498db',
    marginBottom: '20px',
    marginTop: '30px',
    borderBottom: '1px solid #eee',
    paddingBottom: '10px'
  };


  return (
    <div style={containerStyle}>
      {isArabic ? (
        // المحتوى باللغة العربية
        <>
          <h1 style={{ textAlign: 'center', color: '#3498db', marginBottom: '30px' }}>
            شروط وأحكام الخدمة
          </h1>
          
          <p style={{ color: '#95a5a6', fontStyle: 'italic' }}>تاريخ آخر تحديث: 20 مايو 2025</p>
          
          <h2 style={headingStyle}>1. مقدمة</h2>
          <p>
            مرحبًا بك في منصة ATDelivery. تحكم شروط الخدمة هذه استخدامك لتطبيق ATDelivery للسائقين، 
            بما في ذلك أي محتوى أو وظائف أو خدمات متاحة من خلال التطبيق.
          </p>
          <p>
            باستخدام التطبيق، فإنك توافق على الالتزام بهذه الشروط. إذا كنت لا توافق على هذه الشروط،
            فيرجى عدم استخدام التطبيق.
          </p>
          
          <h2 style={headingStyle}>2. الأهلية</h2>
          <p>
            يجب أن تكون بعمر 18 عامًا على الأقل لاستخدام هذه الخدمة. من خلال استخدام هذه الخدمة، 
            فإنك تؤكد أنك تستوفي متطلبات الأهلية هذه.
          </p>
          
          <h2 style={headingStyle}>3. حساب المستخدم</h2>
          <p>
            لاستخدام بعض ميزات تطبيقنا، قد تحتاج إلى إنشاء حساب. أنت مسؤول عن الحفاظ على سرية حسابك،
            بما في ذلك كلمة المرور، وعن جميع الأنشطة التي تحدث تحت حسابك.
          </p>
          <p>
            أنت توافق على إخطارنا فورًا بأي استخدام غير مصرح به لحسابك. لا يمكننا ولن نكون مسؤولين عن أي
            خسارة أو ضرر ينتج عن فشلك في الامتثال لهذا الالتزام.
          </p>
          
          <h2 style={headingStyle}>4. الخدمات والدفع</h2>
          <p>
            نحن نوفر منصة تربط بين المطاعم والعملاء والسائقين لتسهيل توصيل الطعام. 
            كسائق، ستتلقى رسوم توصيل مقابل خدماتك وفقًا للشروط المتفق عليها.
          </p>
          <p>
            قد نقوم بتغيير الرسوم من وقت لآخر، وسنقدم إشعارًا معقولًا بأي تغييرات في الرسوم.
            استمرار استخدامك للتطبيق بعد نشر أي تغييرات يعني موافقتك على الرسوم المعدلة.
          </p>
          
          <h2 style={headingStyle}>5. سلوك السائق</h2>
          <p>
            أنت توافق على توفير خدمات التوصيل بطريقة مهنية وآمنة. يجب عليك الالتزام بجميع قوانين المرور واللوائح المحلية،
            والحفاظ على مستوى مناسب من النظافة والمظهر المهني.
          </p>
          <p>
            يجب أن تضمن أن طلبات الطعام يتم توصيلها في حالة جيدة ووفقًا لأي تعليمات محددة من المطعم أو العميل.
          </p>
          
          <h2 style={headingStyle}>6. التوافر وقبول الطلبات</h2>
          <p>
            أنت لست مطالبًا بالعمل لساعات محددة، ولكن عندما تكون متاحًا على التطبيق، يُتوقع منك قبول ومعالجة
            طلبات التوصيل في وقت معقول.
          </p>
          <p>
            نحتفظ بالحق في تعليق أو إنهاء حسابك إذا انخفض معدل قبول الطلبات أو تقييمات الخدمة لديك بشكل كبير.
          </p>
          
          <h2 style={headingStyle}>7. الخصوصية</h2>
          <p>
            نحن نقدر خصوصيتك ونعمل بجد للحفاظ على معلوماتك الشخصية آمنة. راجع سياسة الخصوصية الخاصة بنا
            لمزيد من المعلومات حول كيفية جمع واستخدام بياناتك.
          </p>
          
          <h2 style={headingStyle}>8. الملكية الفكرية</h2>
          <p>
            التطبيق ومحتواه، بما في ذلك على سبيل المثال لا الحصر، النصوص والرسومات والشعارات وأيقونات الزر
            والصور والمقاطع الصوتية والمقاطع المرئية والبرامج وتجميع المحتوى، هي ملك للشركة
            أو مرخصيها وتخضع للحماية بموجب قوانين حقوق النشر والملكية الفكرية.
          </p>
          
          <h2 style={headingStyle}>9. الإنهاء</h2>
          <p>
            يمكننا إنهاء أو تعليق حسابك وحقك في استخدام التطبيق، فورًا ودون إشعار أو مسؤولية،
            لأي سبب، بما في ذلك على سبيل المثال لا الحصر، انتهاك شروط الخدمة هذه.
          </p>
          <p>
            عند الإنهاء، سيتوقف حقك في استخدام التطبيق على الفور. إذا كنت ترغب في إنهاء حسابك،
            فيمكنك ببساطة التوقف عن استخدام التطبيق.
          </p>
          
          <h2 style={headingStyle}>10. التغييرات على الشروط</h2>
          <p>
            نحتفظ بالحق في تعديل هذه الشروط في أي وقت. سنقوم بإخطارك بأي تغييرات من خلال نشر الشروط الجديدة
            على التطبيق. تغييرات الشروط سارية فور نشرها على التطبيق.
          </p>
          <p>
            استمرار استخدامك للتطبيق بعد نشر التغييرات يعني قبولك للشروط المعدلة.
          </p>
          
          <h2 style={headingStyle}>11. التواصل</h2>
          <p>
            إذا كانت لديك أي أسئلة حول شروط الخدمة هذه، يرجى التواصل معنا على:
          </p>
          <p>البريد الإلكتروني: info@atdelivery.net</p>
          <p>الموقع: www.atdelivery.net</p>
          
          <div style={{ marginTop: '50px', textAlign: 'center', color: '#7f8c8d', fontSize: '0.9em' }}>
            <p>© 2025 ATDelivery. جميع الحقوق محفوظة.</p>
          </div>
        </>
      ) : (
        // المحتوى باللغة الإنجليزية
        <>
          <h1 style={{ textAlign: 'center', color: '#3498db', marginBottom: '30px' }}>
            Terms and Conditions of Service
          </h1>
          
          <p style={{ color: '#95a5a6', fontStyle: 'italic' }}>Last Updated: May 20, 2025</p>
          
          <h2 style={headingStyle}>1. Introduction</h2>
          <p>
            Welcome to ATDelivery platform. These Terms of Service govern your use of the ATDelivery Driver App, 
            including any content, functionality, or services offered on or through the app.
          </p>
          <p>
            By using the app, you agree to comply with these terms. If you do not agree with these terms, 
            please do not use the app.
          </p>
          
          <h2 style={headingStyle}>2. Eligibility</h2>
          <p>
            You must be at least 18 years old to use this service. By using this service, 
            you confirm that you meet these eligibility requirements.
          </p>
          
          <h2 style={headingStyle}>3. User Account</h2>
          <p>
            To use certain features of our app, you may need to create an account. You are responsible for maintaining the confidentiality of your account, 
            including your password, and for all activities that occur under your account.
          </p>
          <p>
            You agree to notify us immediately of any unauthorized use of your account. We cannot and will not be liable for any loss or damage resulting from your failure to comply with this obligation.
          </p>
          
          <h2 style={headingStyle}>4. Services and Payment</h2>
          <p>
            We provide a platform connecting restaurants, customers, and drivers to facilitate food delivery. 
            As a driver, you will receive delivery fees for your services according to the agreed terms.
          </p>
          <p>
            We may change the fees from time to time and will provide reasonable notice of any changes to the fees. 
            Your continued use of the app after posting of any changes constitutes your acceptance of the modified fees.
          </p>
          
          <h2 style={headingStyle}>5. Driver Conduct</h2>
          <p>
            You agree to provide delivery services in a professional and safe manner. You must comply with all traffic laws and local regulations, 
            and maintain an appropriate level of cleanliness and professional appearance.
          </p>
          <p>
            You must ensure that food orders are delivered in good condition and according to any specific instructions from the restaurant or customer.
          </p>
          
          <h2 style={headingStyle}>6. Availability and Order Acceptance</h2>
          <p>
            You are not required to work specific hours, but when you are available on the app, you are expected to accept and process 
            delivery orders within a reasonable time frame.
          </p>
          <p>
            We reserve the right to suspend or terminate your account if your order acceptance rate or service ratings fall significantly.
          </p>
          
          <h2 style={headingStyle}>7. Privacy</h2>
          <p>
            We value your privacy and work hard to keep your personal information secure. Please review our Privacy Policy 
            for more information about how we collect and use your data.
          </p>
          
          <h2 style={headingStyle}>8. Intellectual Property</h2>
          <p>
            The app and its content, including but not limited to text, graphics, logos, button icons, images, audio clips, video clips, software, and the compilation of the content, are owned by the Company 
            or its licensors and are protected by copyright and intellectual property laws.
          </p>
          
          <h2 style={headingStyle}>9. Termination</h2>
          <p>
            We may terminate or suspend your account and right to use the app, immediately and without notice or liability, 
            for any reason, including without limitation if you breach these Terms of Service.
          </p>
          <p>
            Upon termination, your right to use the app will immediately cease. If you wish to terminate your account, 
            you may simply discontinue using the app.
          </p>
          
          <h2 style={headingStyle}>10. Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. We will notify you of any changes by posting the new terms 
            on the app. Changes to the terms are effective immediately upon posting on the app.
          </p>
          <p>
            Your continued use of the app after the posting of changes constitutes your acceptance of the modified terms.
          </p>
          
          <h2 style={headingStyle}>11. Contact Us</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at:
          </p>
          <p>Email: info@atdelivery.net</p>
          <p>Website: www.atdelivery.net</p>
          
          <div style={{ marginTop: '50px', textAlign: 'center', color: '#7f8c8d', fontSize: '0.9em' }}>
            <p>© 2025 ATDelivery. All rights reserved.</p>
          </div>
        </>
      )}
    </div>
  );
};

export default TermsOfService;